const tableCellService = {
  photo: 'PHOTO'
};

export default tableCellService;
